import { basePixelAmount } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const typography: Styleguide["typography"] = {
    ".fr-view": {
        css: css`
            &:not(#important) {
                ${({ theme }) => css`
                    ${theme.typography.body.css}
                    font-size: ${basePixelAmount}px;
                    max-width: calc(${theme.design.layout.contentWidth}px + 40px);
                    padding: 20px;
                    margin: 0 auto;

                    ul {
                        ${theme.lists.defaultProps?.css}
                        ${theme.lists.unorderedListProps?.css}
                    }

                    ol {
                        ${theme.lists.defaultProps?.css}
                        ${theme.lists.orderedListProps?.css}
                    }

                    li {
                        ${theme.lists.listItemProps?.css}
                    }

                    a {
                        ${theme.link.defaultProps?.css}
                    }
                `}
            }
        `,
    },
};

export default typography;
